import { useContext } from 'react';

import { RecipesContext } from './RecipesProvider';

const useRecipes = () => {
  const { myRecipes, loadMyRecipes, loadMyRecipesStatus } = useContext(
    RecipesContext
  );

  return { myRecipes, loadMyRecipes, loadMyRecipesStatus };
};

export default useRecipes;
